/**
 * 首次访问弹窗持久化状态管理
 *
 * 使用 LocalStorage 存储标记，key: `550w_qzm_first_visit_shown`
 * 读写失败静默忽略（Safari 隐私模式、磁盘配额等场景）
 *
 * 参见 requirements 8.1 / 8.6
 */

export const FIRST_VISIT_STORAGE_KEY = '550w_qzm_first_visit_shown';

/**
 * 判断是否应展示首次访问弹窗
 * - 未记录过标记 → 应展示
 * - LocalStorage 读取失败 → 不展示（requirements 8.1：静默忽略）
 *
 * @returns {boolean} true 表示应展示首次访问弹窗
 */
export function shouldShowFirstVisit() {
  try {
    return localStorage.getItem(FIRST_VISIT_STORAGE_KEY) !== 'true';
  } catch (e) {
    // 读取失败（如 Safari 隐私模式）：静默忽略，不展示
    return false;
  }
}

/**
 * 写入弹窗已展示标记，写入失败静默忽略（requirements 8.6）
 *
 * @returns {boolean} true 表示写入成功
 */
export function markFirstVisitShown() {
  try {
    localStorage.setItem(FIRST_VISIT_STORAGE_KEY, 'true');
    return true;
  } catch (e) {
    // 写入失败（如容量满）静默忽略
    return false;
  }
}
